import { useState } from "react";
import { RunSheet } from "./RunSheet";
import type { RunHeat, RunRider } from "./model";
export function FallSheet({
  heat,
  rider,
  close,
  record,
}: {
  heat: RunHeat;
  rider: RunRider;
  close: () => void;
  record: (payload: Record<string, unknown>) => Promise<unknown>;
}) {
  const [pass, setPass] = useState(1);
  const [out, setOut] = useState(false);
  const [past, setPast] = useState(false);
  const [bonus, setBonus] = useState(false);
  const [cause, setCause] = useState("");
  const [counted, setCounted] = useState(true);
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const format = heat.format;
  return (
    <RunSheet title="Record fall" close={close}>
      {error && <p role="alert">{error}</p>}
      <p>
        {rider.name} · Attempt {rider.current_attempt}
      </p>
      <form
        onSubmit={async (e) => {
          e.preventDefault();
          setBusy(true);
          try {
            const accepted = await record({
              heat_rider_id: rider.heat_rider_id,
              attempt_number: rider.current_attempt,
              pass_number: pass,
              out_of_course: out,
              past_marker: past,
              bonus_pending: bonus,
              counted: counted && cause !== "wrong_loop",
              ...(cause ? { cause } : {}),
              ...(reason.trim() ? { reason: reason.trim() } : {}),
            });
            if (accepted) close();
            else setError("Could not save this fall on this device. Your entry has been kept.");
          } finally {
            setBusy(false);
          }
        }}
      >
        {(format?.passes_per_attempt ?? 1) > 1 && (
          <label>
            Pass
            <select value={pass} onChange={(e) => setPass(Number(e.target.value))}>
              {Array.from({ length: format?.passes_per_attempt ?? 1 }, (_, i) => i + 1).map((p) => (
                <option key={p} value={p}>
                  {p}
                </option>
              ))}
            </select>
          </label>
        )}
        {format?.out_of_course_window && (
          <label className="run-toggle">
            <input type="checkbox" checked={out} onChange={(e) => setOut(e.target.checked)} />
            Out of course
          </label>
        )}
        {format?.fall_past_marker_ends_run && format.fall_past_marker_ends_run !== "none" && (
          <label className="run-toggle">
            <input type="checkbox" checked={past} onChange={(e) => setPast(e.target.checked)} />
            Past marker
          </label>
        )}
        {format?.bonus_element && format.bonus_element !== "none" && (
          <label className="run-toggle">
            <input type="checkbox" checked={bonus} onChange={(e) => setBonus(e.target.checked)} />
            Bonus still pending
          </label>
        )}
        <label>
          Cause
          <select
            value={cause}
            onChange={(e) => {
              setCause(e.target.value);
              if (e.target.value === "wrong_loop") {
                setOut(true);
                setPass(1);
              }
            }}
          >
            <option value="">Fall</option>
            <option value="equipment_failure">Equipment failure</option>
            {format?.out_of_course_window && (
              <option value="wrong_loop">Officials’ wrong loop — not counted</option>
            )}
          </select>
        </label>
        <label className="run-toggle">
          <input
            type="checkbox"
            checked={!counted}
            onChange={(e) => setCounted(!e.target.checked)}
          />
          Not counted
        </label>
        <label>
          Reason{!counted || cause === "wrong_loop" ? " (required)" : ""}
          <textarea
            required={!counted || cause === "wrong_loop"}
            maxLength={2000}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
        </label>
        <button
          className="run-primary"
          disabled={busy || ((!counted || cause === "wrong_loop") && !reason.trim())}
        >
          Record fall
        </button>
      </form>
      <button onClick={close}>Cancel</button>
    </RunSheet>
  );
}
